import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiReact,
  DiHtml5,
  DiSass,
  DiBootstrap,
  DiNodejs,
  DiPostgresql,
  DiMongodb,
} from "react-icons/di";
import {
  SiTailwindcss,
  SiTypescript,
  SiJavascript,
  SiRedux,
  SiReactquery,
  SiMui,
  SiAntdesign,
  SiExpress,
  SiPrisma,
  SiSocketdotio,
  SiElectron,
} from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <span className="">CSS3</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJavascript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <span className="">Next.js</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedux />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiReactquery />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <span className="">Three.js</span>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiMui />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAntdesign />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTailwindcss />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiBootstrap />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiSass />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <span className="">shadcn-ui</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <span className="">Headless UI</span>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <span className="">Recharts</span>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiExpress />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPostgresql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPrisma />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <span className="">SQLite3</span>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiSocketdotio />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiElectron />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <span className="">Flask</span>
      </Col>
    </Row>
  );
}

export default Techstack;
